import React from 'react'
import { CircularProgress } from '@material-ui/core'
import Assets from 'app/configs/assetConfigs'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const MessagespringLoading = (props) => {
  const { size = 64 } = props
  return (
    <div className={clsx(`position w-${size} h-${size} flex`)}>
      <CircularProgress className="absolute" size={size} />
      <div className="w-24 h-24 m-auto">
        <img src={Assets.logo} alt="Messagespring icon" />
      </div>
    </div>
  )
}

MessagespringLoading.propTypes = {
  size: PropTypes.number,
}

export default MessagespringLoading
